import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { AnomalyTypeFilter } from "src/models/tna/tna-anomalies/anomaly-type/anomaly-type-filter";
import { AnomalyTypes } from "src/services/tna-anomalies/anomaly-types-api.service";
import { Props, State, AnomalyTypeOptionValue, AnomalyTypeQuickFilter } from "./interfaces";
import { AnomalyTypeDTO } from "../../../models/tna/tna-anomalies/anomaly-type/anomaly-type-dto";
import { QuickFilterOption } from "../../../reusable-components/QuickFilter/interfaces";
import QuickFilter from "../../../reusable-components/QuickFilter/QuickFilter";

export const AnomalyTypesQuickfilter = <Q extends AnomalyTypeQuickFilter>({
  quickFilters,
  handleChangeQuickFilters,
  allAnomalyTypesOption,
  isMultiSelect,
  allAnomalyTypes,
}: Props<Q>) => {
  const { t } = useTranslation();
  const tRP = "components.quickfilters.anomaly_types";

  const [anomalyTypes, setCurrAnomalyTypes] = useState<AnomalyTypeDTO[]>([]);

  // useEffect(() => {
  //   setCurrAnomalyTypes(allAnomalyTypes || []);

  //   const newOptions: QuickFilterOption<AnomalyTypeOptionValue>[] = (allAnomalyTypes || []).map((type) => ({
  //     name: type.description || type.name,
  //     value: { anomalyTypeIds: [type.id] },
  //     code: type.code,
  //   }));

  //   setOptions({
  //     customOptions: [
  //       ...(allAnomalyTypesOption
  //         ? [
  //             {
  //               name: t(`${tRP}.all_anomaly_types`),
  //               value: {
  //                 anomalyTypeIds: allAnomalyTypes ? [] : [],
  //                 // ...allAnomalyTypes.map((type) => type.id)
  //               },
  //             },
  //           ]
  //         : []),
  //     ],
  //     computedOptions: newOptions,
  //   });
  // }, [allAnomalyTypes, allAnomalyTypesOption]);

  const [loadAnomalyTypes, setLoadAnomalyTypes] = useState<boolean>(false);

  const [options, setOptions] = useState<State>({
    customOptions: [
      ...(allAnomalyTypesOption
        ? [
            {
              name: t(`${tRP}.all_anomaly_types`),
              value: {
                anomalyTypeIds: [],
              },
            },
          ]
        : []),
    ],
    computedOptions: [],
  });

  useEffect(() => {
    if (anomalyTypes.length > 0) {
      const newOptions: QuickFilterOption<AnomalyTypeOptionValue>[] = anomalyTypes.map((type) => ({
        name: `${type.description || type.name} (${type.code})`,
        value: { anomalyTypeIds: [type.id] },
        // code: type.code,
      }));

      setOptions((state) => ({ ...state, computedOptions: newOptions }));
    }
  }, [anomalyTypes]);

  const loadNewItems = () => {
    setLoadAnomalyTypes(true);
  };

  const loadItemCallback = useCallback(async (signal: AbortSignal) => {
    setLoadAnomalyTypes(true);
    try {
      const response = await new AnomalyTypes().loadItems(
        { isAbnormalPresence: false } as AnomalyTypeFilter,
        undefined,
        undefined,
        { pageNumber: 0, pageSize: 1000 },
        undefined,
        60,
        signal
      );
      if (!response.error) {
        setCurrAnomalyTypes(response.items as AnomalyTypeDTO[]);
      }
    } catch (error: any) {
      console.error(error);
    } finally {
      setLoadAnomalyTypes(false);
    }
  }, []);

  useEffect(() => {
    const abortController = new AbortController();

    loadAnomalyTypes && loadItemCallback(abortController.signal);

    return () => {
      abortController.abort();
    };
  }, [loadAnomalyTypes, loadItemCallback]);

  return (
    <QuickFilter
      loading={loadAnomalyTypes}
      loadNewItems={loadNewItems}
      allItems={anomalyTypes}
      options={[...options.customOptions, ...options.computedOptions]}
      quickFilters={quickFilters}
      quickFilter="anomalyTypes"
      handleChangeQuickFilter={handleChangeQuickFilters}
      shrinkedLabel={t(`${tRP}.shrinked_label`)}
      isMultiSelect={isMultiSelect}
      multiSelectField="anomalyTypeIds"
      customWidth={"200px"}
      // maxMenuWidth="340px"
    />
  );
};
